import React from "react";
import _ from "lodash";
import "react-day-picker/lib/style.css";
import { Select, Tooltip, Button, Input, Modal, Progress } from "antd";
import { connect } from "react-redux";
import {
    routeSelected,
    selectMarker,
    reviewMarker,
    setMarkerConditionType,
    reviewSessionObservation,
    classifyContinuousObservation,
    customAudit,
    setObservationClassification,
    selectTag,
    classifyObservationsObject,
    classifyScrapRailLength,
    setObservationConditionType,
} from "redux/actions/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faEyeSlash,
    faQuestionCircle,
    faTimesCircle,
    faArrowRight,
    faArrowLeft,
} from "@fortawesome/pro-solid-svg-icons";
import memoizeOne from "memoize-one";
import {
    filterMarkers,
    keyLookup,
    nextContent,
    previousContent,
    jumpToContent,
    findNextExtent,
    findPreviousExtent,
    filterSessionObservations,
    getReviewLabel,
    findClosestMarker,
    videoKeyToTimestamp,
    calculateFrame,
    processTroughingBbox,
    capitalizeFirstLetter,
    combineLowBallastBboxes,
} from "./util/PlaylistUtils";
import { getColorFromPercentage } from "./util/FabricUtils";
import MarkerThresholdFiltersModal from "./MarkerThresholdFiltersModal";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import MarkerHistoryComponent from "./MarkerHistoryComponent";
import OBCAutoIndicator from "./OBC/OBCAutoIndicator";
import AssetIDHelper from "components/util/AssetIDHelper";
import { MEMOIZED_DOMAIN_URL } from "./util/HostUtils";
import { calculatePointDistance } from "./util/Geometry";
import MarkerPanel from "./route/MarkerPanel";
import MarkerExportModal, { OBSERVATION_EXPORT_BLACKLIST } from "./MarkerExportModal";
import { getRawApiImage } from "./RawImageComponent";
import ObservationHistoryComponent from "./ObservationHistoryComponent";
import { validateGroundTruth } from "./Issues/groundTruthUtils";
import { formatHumanDate } from "./util/TimezoneUtils";
import { shortcutLabel } from "./helpers/uiHelpers";
import { degreesToUserPreference, getTempUnit } from "./util/TemperatureUtils";

const { Option } = Select;
class MarkerInformation extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            markerThresholdFilterOpen: false,
            jumpToOpen: false,
            previewOpen: false,
            preveiwImgSrc: null,
            isObservation: false,
            isContinuousObservation: false,
            continuousObservations: [],
            uniqueContinuousObservations: [],
            observationExtents: [],
            overallRailClassification: {},
            modalVisible: false,
            ocrResult: "",
            ocrVerificationMessage: "",
            observationsExportOpen: false,
            isNavigating: false,
            observation: null,
        };
        this.conditionSelect = React.createRef();
        this.canvasRef = React.createRef();
    }

    setContinuousObservationState = () => {
        if (this.props.selectedMarker.hasOwnProperty("observation_number")) {
            this.setState({
                isObservation: true,
            });
            if (this.props.selectedMarker.continuous) {
                const continuousObservations = _.map(this.props.markers, (marker) => {
                    const obs = _.minBy(
                        this.props.allMatchingMarkers.filter((o) => o.observation_number === marker.observation_number),
                        "extent_number",
                    );
                    return { ...marker, first_video_key: obs.video_key, first_observation_frame: obs.frame };
                });
                let uniqueObservations = [];
                continuousObservations.forEach((item) => {
                    if (!_.find(uniqueObservations, { observation_number: item.observation_number })) {
                        uniqueObservations.push(item);
                    }
                });
                let observationExtents = continuousObservations.filter((item) => item.observation_number === this.props.selectedMarker.observation_number);
                this.setState({
                    isContinuousObservation: true,
                    continuousObservations: continuousObservations,
                    uniqueContinuousObservations: uniqueObservations,
                    observationExtents: observationExtents,
                });
            } else {
                this.setState({
                    isContinuousObservation: false,
                    continuousObservations: [],
                    uniqueContinuousObservations: [],
                    observationExtents: [],
                });
            }
        } else {
            this.setState({
                isObservation: false,
                continuousObservations: [],
                isContinuousObservation: false,
                uniqueContinuousObservations: [],
                observationExtents: [],
            });
        }
    };

    componentDidMount() {
        this.setContinuousObservationState();
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.selectedMarker.id !== prevProps.selectedMarker.id ||
            (this.props.selectedMarker.classifications && this.props.selectedMarker.classifications !== prevProps.selectedMarker.classifications)
        ) {
            this.setContinuousObservationState();
        }
        if (this.props.markers.length !== prevProps.markers.length) {
            if (this.props.selectedMarker.continuous) {
                const continuousObservations = _.map(this.props.markers, (marker) => {
                    const obs = _.minBy(
                        this.props.allMatchingMarkers.filter((o) => o.observation_number === marker.observation_number),
                        "extent_number",
                    );
                    return { ...marker, first_video_key: obs.video_key, first_observation_frame: obs.frame };
                });
                let uniqueObservations = [];
                continuousObservations.forEach((item) => {
                    if (!_.find(uniqueObservations, { observation_number: item.observation_number })) {
                        uniqueObservations.push(item);
                    }
                });
                let observationExtents = continuousObservations.filter((item) => item.observation_number === this.props.selectedMarker.observation_number);
                this.setState({
                    isContinuousObservation: true,
                    continuousObservations: continuousObservations,
                    uniqueContinuousObservations: uniqueObservations,
                    observationExtents: observationExtents,
                });

                if (!_.find(observationExtents, (o) => o.id === this.props.selectedMarker.id)) {
                    if (observationExtents.length > 0) {
                        this.props.dispatch(selectMarker(uniqueObservations[0], true));
                        this.props.dispatch(
                            routeSelected(this.props.sessionID, uniqueObservations[0].video_key, undefined, undefined, undefined, uniqueObservations[0].frame),
                        );
                    }
                }
            } else {
                this.setState({
                    isContinuousObservation: false,
                    continuousObservations: [],
                    uniqueContinuousObservations: [],
                    observationExtents: [],
                });
            }
        }
        if (this.props.selectedMarker.id !== prevProps.selectedMarker.id && !_.isEmpty(this.props.selectedMarker && !this.state.isNavigating)) {
            this.props.dispatch(selectMarker(this.props.selectedMarker, _.has(this.props.selectedMarker, "observation_number")));
        }
    }

    nextMarker = () => {
        if (this.state.isNavigating) return;
        this.setState({ isNavigating: true });

        let next;
        if (this.state.isContinuousObservation) {
            let observationNumber = _.get(this.props.selectedMarker, "observation_number", -1);
            next = nextContent(
                this.state.uniqueContinuousObservations,
                1,
                this.props.currentIndex,
                this.props.imageKeys,
                this.props.currentTimeOffset,
                observationNumber,
            );
        } else {
            next = nextContent(
                this.props.markers,
                1,
                this.props.currentIndex,
                this.props.imageKeys,
                this.props.currentTimeOffset,
                -1,
                this.props.selectedMarker,
            );
        }
        if (next === null) {
            this.setState({ isNavigating: false });
            return;
        }
        let selectedMarkerName = this.state.isObservation ? this.props.selectedMarker.class : this.props.selectedMarker.name;
        this.props.dispatch(
            customAudit(
                "detection_navigation_click",
                { direction: "next", detection_type: selectedMarkerName, target: "Detection Info Tab", source: "mouse" },
                `detection_navigation_click button next clicked from Detection Info tab for ${selectedMarkerName}`,
            ),
        );
        const marker = next[2];
        this.props.dispatch(selectMarker(marker, this.state.isObservation));
        this.props.dispatch(routeSelected(this.props.sessionID, marker.video_key, undefined, undefined, undefined, marker.frame));
        this.setState({ isNavigating: false });
    };

    prevMarker = () => {
        if (this.state.isNavigating) return;
        this.setState({ isNavigating: true });

        let prev;
        if (this.state.isContinuousObservation) {
            let observationNumber = _.get(this.props.selectedMarker, "observation_number", -1);
            prev = previousContent(
                this.state.uniqueContinuousObservations,
                1,
                this.props.currentIndex,
                this.props.imageKeys,
                this.props.currentTimeOffset,
                observationNumber,
            );
        } else {
            prev = previousContent(
                this.props.markers,
                1,
                this.props.currentIndex,
                this.props.imageKeys,
                this.props.currentTimeOffset,
                -1,
                this.props.selectedMarker,
            );
        }
        if (prev === null) {
            this.setState({ isNavigating: false });
            return;
        }
        let selectedMarkerName = this.state.isObservation ? this.props.selectedMarker.class : this.props.selectedMarker.name;
        this.props.dispatch(
            customAudit(
                "detection_navigation_click",
                { direction: "previous", detection_type: selectedMarkerName, target: "Detection Info Tab", source: "mouse" },
                `detection_navigation_click button previous clicked from Detection Info tab for ${selectedMarkerName}`,
            ),
        );
        const marker = prev[2];
        this.props.dispatch(selectMarker(marker, this.state.isObservation));
        this.props.dispatch(routeSelected(this.props.sessionID, marker.video_key, undefined, undefined, undefined, marker.frame));
        this.setState({ isNavigating: false });
    };

    nextExtent = (observations = null, selectedMarker = null) => {
        if (this.state.isNavigating) return;
        this.setState({ isNavigating: true });

        let next = findNextExtent(
            observations ? observations : this.state.continuousObservations,
            this.props.imageKeys,
            selectedMarker ? selectedMarker : this.props.selectedMarker,
        );
        if (next === null) {
            this.setState({ isNavigating: false });
            return;
        }
        const marker = next[2];
        this.props.dispatch(selectMarker(marker, this.state.isObservation));
        this.props.dispatch(routeSelected(this.props.sessionID, marker.video_key, undefined, undefined, undefined, marker.frame));
        let selectedMarkerName = this.state.isObservation ? this.props.selectedMarker.class : this.props.selectedMarker.name;
        this.props.dispatch(
            customAudit(
                "detection_navigation_click",
                { direction: "next", detection_type: selectedMarkerName, target: "Detection Info Tab", source: "mouse" },
                `detection_navigation_click button next clicked from Detection Info tab for ${selectedMarkerName}`,
            ),
        );
        this.setState({ isNavigating: false });
    };

    prevExtent = () => {
        if (this.state.isNavigating) return;
        this.setState({ isNavigating: true });

        let prev = findPreviousExtent(this.state.continuousObservations, this.props.imageKeys, this.props.selectedMarker);
        if (prev === null) {
            this.setState({ isNavigating: false });
            return;
        }
        const marker = prev[2];
        this.props.dispatch(selectMarker(marker, this.state.isObservation));
        this.props.dispatch(routeSelected(this.props.sessionID, marker.video_key, undefined, undefined, undefined, marker.frame));
        let selectedMarkerName = this.state.isObservation ? this.props.selectedMarker.class : this.props.selectedMarker.name;
        this.props.dispatch(
            customAudit(
                "detection_navigation_click",
                { direction: "previous", detection_type: selectedMarkerName, target: "Detection Info Tab", source: "mouse" },
                `detection_navigation_click button previous clicked from Detection Info tab for ${selectedMarkerName}`,
            ),
        );
        this.setState({ isNavigating: false });
    };

    goToMarker = (value) => {
        let next;
        if (this.state.isContinuousObservation) {
            next = jumpToContent(this.state.uniqueContinuousObservations, this.props.imageKeys, value);
        } else {
            next = jumpToContent(this.props.markers, this.props.imageKeys, value);
        }
        if (next === null) {
            this.setState({
                jumpToOpen: false,
            });
            return;
        }
        this.setState({
            jumpToOpen: false,
        });

        const marker = next[2];
        this.props.dispatch(selectMarker(marker, this.state.isObservation));
        this.props.dispatch(routeSelected(this.props.sessionID, marker.video_key, undefined, undefined, undefined, marker.frame));
    };

    goToExtent = (value) => {
        let next = jumpToContent(this.state.observationExtents, this.props.imageKeys, value);

        if (next === null) {
            return;
        }

        const marker = next[2];
        this.props.dispatch(selectMarker(marker, this.state.isObservation));
        this.props.dispatch(routeSelected(this.props.sessionID, marker.video_key, undefined, undefined, undefined, marker.frame));
    };

    reviewObservation = (review) => {
        const continuousObservations = _.cloneDeep(this.state.continuousObservations);
        const _selectedMarker = _.cloneDeep(this.props.selectedMarker);
        const _this = this;

        this.props.dispatch(
            reviewSessionObservation(
                this.props.selectedMarker.id,
                this.state.isContinuousObservation,
                review,
                this.props.selectedMarker.observation_type,
                this.props.selectedMarker.class,
                (success) => {
                    if (success) {
                        if (this.state.isContinuousObservation) {
                            _this.nextExtent(continuousObservations, _selectedMarker);
                        } else {
                            _this.nextMarker();
                        }
                        this.props.dispatch(
                            customAudit(
                                "detection_review_click",
                                {
                                    review: getReviewLabel(review),
                                    detection_type: this.props.selectedMarker.class,
                                    target: "Detection Info Tab",
                                    source: "mouse",
                                },
                                `detection_review_click button ${getReviewLabel(review)} clicked from Detection Info tab for ${this.props.selectedMarker.class} ID: ${this.props.selectedMarker.id}, session ${this.props.sessionID}`,
                            ),
                        );
                    }
                },
            ),
        );
    };

    revMarker = (review) => {
        const _this = this;
        if (this.props.selectedMarker) {
            if (this.state.isObservation) {
                this.reviewObservation(review);
            } else {
                this.props.dispatch(
                    reviewMarker(this.props.selectedMarker.id, review, this.props.sessionID, (success) => {
                        if (success) {
                            _this.nextMarker();
                            this.props.dispatch(
                                customAudit(
                                    "detection_review_click",
                                    {
                                        review: getReviewLabel(review),
                                        detection_type: this.props.selectedMarker.name,
                                        target: "Detection Info Tab",
                                        source: "mouse",
                                    },
                                    `detection_review_click button ${getReviewLabel(review)} clicked from Detection Info tab for ${this.props.selectedMarker.name} ID: ${this.props.selectedMarker.id}, session ${this.props.sessionID}`,
                                ),
                            );
                        }
                    }),
                );
            }
        }
    };

    reviewPermissions = () => {
        let session = this.props.session;
        const reviewPermissions =
            !!_.get(this.props.data_pool_permissions, [_.get(session, ["data_pool"], false), "review"], false) || this.props.userDetails.userConfig.super_admin;
        return reviewPermissions;
    };

    onConditionChanged = (sessionID, detectionID, conditionName) => {
        this.props.dispatch(setMarkerConditionType(sessionID, detectionID, conditionName));
    };

    onObservationConditionChanged = (observationID, conditionName, observationType) => {
        this.props.dispatch(setObservationConditionType(observationID, conditionName, observationType));
    };

    onMarkerIndexDoubleClick = (value) => {
        if (value === 2) {
            this.setState({
                jumpToOpen: true,
            });
        }
    };

    onMarkerIndexInputChanged = (value, position) => {
        if (value !== position + 1) {
            this.goToMarker(value, this.props.selectedMarker.continuous);
        } else {
            this.setState({
                jumpToOpen: false,
            });
        }
    };

    openPreviewWithImage = (src, observation) => {
        this.setState({
            previewOpen: true,
            preveiwImgSrc: src,
            observation: observation,
        });
    };

    closePreviewModal = () => {
        this.setState({
            previewOpen: false,
        });
    };

    classifyObservationExtent = (e, option) => {
        this.props.dispatch(classifyContinuousObservation([this.props.selectedMarker.id], option.props.data_type, true, e));
    };

    setOverallClassification = (overrideSectionClassifications) => {
        const observationNumber = this.props.selectedMarker.observation_number;
        const observationClass = this.props.selectedMarker.class;
        const extentsToUpdate = this.props.sessionObservations
            .filter((item) => item.observation_number === observationNumber && item.class === observationClass)
            .map((item) => item.id);

        this.props.dispatch(
            classifyContinuousObservation(
                extentsToUpdate,
                this.state.overallRailClassification.data_type,
                overrideSectionClassifications,
                this.state.overallRailClassification.val,
            ),
        );

        this.setState({ modalVisible: false, overallRailClassification: {} });
    };

    displayModal = (e, option) => {
        this.setState({ overallRailClassification: { data_type: option.props.data_type, val: e }, modalVisible: true });
    };

    handleOCRChange = () => {
        const observation = this.props.selectedMarker;
        const classSpecificData = _.get(observation, "class_specific_data");
        classSpecificData["ocr_result_custom"] = AssetIDHelper.convert_slash_or_hyphen_to_csv(this.state.ocrResult);
        this.props.dispatch(
            setObservationClassification(observation, classSpecificData, (success) => {
                if (success) {
                    this.setState({ ocrResult: "" });
                }
            }),
        );
    };

    setOCRResult = (e) => {
        this.setState({ ocrResult: e.target.value });
        const response = validateGroundTruth("structure_id", e.target.value);
        this.setState({ ocrVerificationMessage: response });
    };

    renderThumbnailImage = memoizeOne((selectedMarkerID, session, canvas) => {
        const selectedMarker = _.find(this.props.markers, { id: selectedMarkerID });

        if (!this.props.currentDashboard || !this.props.currentDashboard["access_token"]) return;

        let rawSrc = null;
        if (!selectedMarker.bbox && selectedMarker.custom_thumbnail) {
            rawSrc = selectedMarker.custom_thumbnail;
        } else if (session && selectedMarker.video_key) {
            rawSrc = `https://raw${MEMOIZED_DOMAIN_URL}/${session.device_uuid}/${session.uuid}/${selectedMarker.video_key}-${selectedMarker.frame}.jpg`;
            if (this.props.csrfToken) {
                rawSrc += `?csrf=${this.props.csrfToken}`;
            }
        }

        const imageSourceConvertCallback = (imageSrc) => {
            let thumbnail = new Image();
            thumbnail.crossOrigin = "anonymous";

            thumbnail.src = imageSrc;
            let ctx;
            if (canvas) {
                ctx = canvas.getContext("2d");

                canvas.width = 600;
                canvas.height = 350;

                thumbnail.onload = () => {
                    let scaleX = canvas.width / thumbnail.naturalWidth;
                    let scaleY = canvas.height / thumbnail.naturalHeight;

                    ctx.drawImage(thumbnail, 0, 0, 600, 350);

                    if (_.has(selectedMarker, "observation_number") && selectedMarker["bbox"]) {
                        let bboxColor = "#47C66B";
                        if (selectedMarker.class === "Troughing") {
                            const autoClassification = _.get(selectedMarker, "classifications.troughing_condition.auto", null);
                            const userClassification = _.get(selectedMarker, "classifications.troughing_condition.user", null);
                            bboxColor = "yellow";

                            if (!userClassification) {
                                if (autoClassification === "good") {
                                    bboxColor = "#47C66B";
                                }
                                if (autoClassification === "defect") {
                                    bboxColor = "red";
                                }
                                if (autoClassification === "invalid" || autoClassification === "no_result" || !autoClassification) {
                                    bboxColor = "white";
                                }
                            } else {
                                if (userClassification === "good") {
                                    bboxColor = "#47C66B";
                                }
                                if (userClassification === "defect") {
                                    bboxColor = "red";
                                }
                                if (userClassification === "invalid") {
                                    bboxColor = "white";
                                }
                            }
                        }

                        let boxCoords = [];
                        let colours = [];
                        if (selectedMarker.class === "low_ballast") {
                            boxCoords = combineLowBallastBboxes(selectedMarker.bbox);
                            _.forEach(boxCoords, (_coord) => {
                                colours.push("red");
                            });
                        } else {
                            const bbox = processTroughingBbox(JSON.parse(selectedMarker.bbox), selectedMarker);
                            boxCoords.push(JSON.parse(selectedMarker.bbox));
                            boxCoords.push(bbox);
                            colours = ["#CCCCCC", bboxColor];
                        }

                        _.forEach(boxCoords, (boxCoord, index) => {
                            if (boxCoord && boxCoord.length) {
                                ctx.strokeStyle = colours[index];
                                ctx.lineWidth = 2;
                                ctx.beginPath();
                                ctx.rect(boxCoord[0] * scaleX, boxCoord[1] * scaleY, boxCoord[2] * scaleX, boxCoord[3] * scaleY);
                                ctx.stroke();
                            }
                        });
                    }
                };
            }
        };
        getRawApiImage(rawSrc, this.props.currentDashboard.access_token, imageSourceConvertCallback);
    });

    changeDetectionType = (detectionType) => {
        const hasObservationDetections = this.props.sessionObservations.some((o) => o.class === detectionType);

        const availableDetections = _.filter(this.props.combinedMarkers, (detection) => {
            return detectionType === (hasObservationDetections ? detection.class : detection.name);
        });

        const closestMarker = findClosestMarker(
            availableDetections,
            this.props.currentVideoKey,
            this.props.playlist,
            this.props.currentIndex,
            this.props.currentTimeOffset,
        );

        this.props.dispatch(
            customAudit(
                "detection_type_selected",
                { detection_type: detectionType, session_id: this.props.sessionID },
                `detection_type_selected used type: ${detectionType}`,
            ),
        );
        this.props.dispatch(selectTag(detectionType));
        this.props.dispatch(selectMarker(closestMarker, _.has(closestMarker, "observation_number")));
        this.props.dispatch(routeSelected(this.props.sessionID, closestMarker.video_key, false, true, undefined, closestMarker.frame));
    };

    renderObjectObservationClassifications = (dataTypes, selectedMarker) => {
        const types = _.get(dataTypes, _.get(selectedMarker, "class"), {});

        const classifications = [];

        Object.keys(types).forEach((type) => {
            const isIsolationField = type.includes("isolation");
            const isWalkwayField = type === "signal_walkway";

            if ((isIsolationField || isWalkwayField) && !_.get(this.props.currentDashboard, ["config", "show_essow_input"], false)) {
                return;
            }

            const classification = _.get(selectedMarker, ["classifications", type], null);

            let statusIndicator;
            let currentClassification = _.get(classification, "user", null);

            if (currentClassification !== null) {
                const userTs = _.get(classification, "user_ts", null);
                statusIndicator = (
                    <Tooltip
                        title={
                            <span>
                                Verified by <strong>{_.get(classification, "source", "Unknown")}</strong>
                                {this.props.userDetails.userConfig.convert_to_utc !== null &&
                                    userTs &&
                                    ` on ${formatHumanDate(userTs, this.props.userDetails.userConfig.convert_to_utc)}`}
                            </span>
                        }>
                        <div className="VerifiedContainer">
                            <FontAwesomeIcon
                                icon={faCheckCircle}
                                className="VerifiedIcon"
                            />
                            <span>Verified</span>
                        </div>
                    </Tooltip>
                );
            } else {
                currentClassification = _.get(classification, "auto", null);

                if (currentClassification !== null) {
                    statusIndicator = (
                        <OBCAutoIndicator
                            tooltip="Click to verify"
                            placement="top"
                            onClick={() => {
                                this.props.dispatch(classifyObservationsObject(selectedMarker.id, type, currentClassification));
                            }}
                        />
                    );
                } else {
                    statusIndicator = null;
                }
            }

            const currentType = types[type];
            const dataValues = _.get(currentType, "data_values", {});
            const label = _.get(currentType, "display_name", "") + (isIsolationField ? "*" : "");

            classifications.push(
                <div className="SignalClassification">
                    <p className="SignalClassificationLabel">
                        {isIsolationField ? <Tooltip title="This data should not be relied upon for safety-critical decision making.">{label}</Tooltip> : label}
                    </p>
                    <Select
                        value={currentClassification ?? undefined}
                        placeholder={`Classify ${_.get(currentType, "display_name", "")}`}
                        className="SignalClassificationSelect"
                        onChange={(value) => {
                            this.props.dispatch(classifyObservationsObject(selectedMarker.id, type, value));
                        }}>
                        {_.map(Object.keys(dataValues), (value) => {
                            if (typeof dataValues[value] === "string") {
                                return <Select.Option value={dataValues[value]}>{value}</Select.Option>;
                            } else {
                                const displayName = _.get(dataValues[value], "display_name", "Unknown");
                                const ragStatus = _.get(dataValues[value], "rag");

                                const colours = {
                                    red: "#E55151",
                                    amber: "#F8C46D",
                                    green: "#47C66B",
                                };

                                if (displayName) {
                                    return (
                                        <Option value={value}>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                {displayName}
                                                {ragStatus && (
                                                    <span
                                                        role="img"
                                                        className="detectionCondition__Rag"
                                                        style={{
                                                            backgroundColor: colours[ragStatus],
                                                            height: "10px",
                                                            width: "10px",
                                                            borderRadius: "50%",
                                                            marginLeft: "5px",
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </Option>
                                    );
                                }
                            }
                        })}
                    </Select>
                    {statusIndicator}
                </div>,
            );
        });

        return classifications;
    };

    renderThermalHotspotDetails = () => {
        if (!this.props.selectedMarker || (this.props.selectedMarker.name !== "Thermal Hotspot" && this.props.selectedMarker.class !== "Thermal Hotspot")) {
            return null;
        }

        const isObservation = this.props.selectedMarker.class === "Thermal Hotspot";
        const userTempUnits = _.get(this.props.userDetails, ["userConfig", "temperature_units"], "celsius");
        const tempUnit = getTempUnit(userTempUnits);
        const { score, temperature, ambient_temperature } = this.props.selectedMarker;

        const hotspotValue = isObservation ? temperature : score;

        return (
            <div className="ThermalHotspotDetails">
                <span className="title">Temperatures</span>
                <dl>
                    <dt className="muted">Hotspot:</dt>
                    <dd>
                        {degreesToUserPreference(hotspotValue, userTempUnits)}
                        <span className="muted">{tempUnit}</span>
                    </dd>

                    {isObservation && (
                        <>
                            <dt className="muted">Average surface:</dt>
                            <dd>
                                {degreesToUserPreference(ambient_temperature, userTempUnits)}
                                <span className="muted">{tempUnit}</span>
                            </dd>
                        </>
                    )}
                </dl>
            </div>
        );
    };

    render() {
        const { selectedMarker } = this.props;
        let markersLength = 0;
        let markerInformationContent = null;
        if (!_.isEmpty(selectedMarker)) {
            this.renderThumbnailImage(selectedMarker.id, this.props.sessions[this.props.sessionID], this.canvasRef.current);

            let reviewStatus = null;
            const statuses = {
                0: { text: "Needs Review", icon: faQuestionCircle, colour: "orange" },
                1: { text: "Verified", icon: faCheckCircle, colour: "lightGreen" },
                2: { text: "Verified & Hidden", icon: faEyeSlash, colour: "darkGreen" },
                3: { text: "Rejected", icon: faTimesCircle, colour: "red" },
            };

            if (!_.isNil(selectedMarker.review_status)) {
                const status = statuses[selectedMarker.review_status];

                if (status.text === "Needs Review") {
                    reviewStatus = (
                        <div className="markerStatus">
                            <div className={`markerStatusContent ${status.colour}`}>
                                <Tooltip title="This detection has not yet been user-verified">
                                    <FontAwesomeIcon icon={status.icon} />
                                </Tooltip>
                                <p>{status.text}</p>
                            </div>
                        </div>
                    );
                } else {
                    reviewStatus = (
                        <div className="markerStatus">
                            <div className={`markerStatusContent ${status.colour}`}>
                                <FontAwesomeIcon icon={status.icon} />
                                <p>{status.text}</p>
                            </div>
                        </div>
                    );
                }
            }

            let position = 0;

            if (this.props.markers && this.props.markers.length) {
                let indexes;
                if (this.props.selectedMarker.continuous) {
                    indexes = _.map(this.state.uniqueContinuousObservations, (marker) => [
                        keyLookup(marker.first_video_key, this.props.imageKeys),
                        marker.frame,
                        marker,
                    ]);
                } else {
                    indexes = _.map(this.props.markers, (marker) => [keyLookup(marker.video_key, this.props.imageKeys), marker.frame, marker]);
                }
                let sortedMarkers = _.sortBy(
                    _.filter(indexes, ([idx, _frame]) => idx > -1),
                    ([idx, _frame]) => idx,
                    ([idx, _frame]) => _frame,
                ).map((marker) => marker[2]);

                position = _.findIndex(sortedMarkers, (i) => i.id === selectedMarker.id);
                if (this.state.isContinuousObservation && position === -1) {
                    position = _.findIndex(sortedMarkers, (i) => i.observation_number === selectedMarker.observation_number);
                }
                markersLength = sortedMarkers.length;
            }

            let markerIndex = (
                <div
                    className="markerIndex"
                    onClick={(e) => this.onMarkerIndexDoubleClick(e.detail)}>
                    {this.state.jumpToOpen ? (
                        <Input.Group compact>
                            <Input
                                size="small"
                                type="number"
                                autoFocus={true}
                                style={{ width: "40px" }}
                                defaultValue={position + 1}
                                onBlur={(e) => this.onMarkerIndexInputChanged(e.target.value, position)}
                                onPressEnter={(e) => this.onMarkerIndexInputChanged(e.target.value, position)}
                                onSearch={(e) => this.onMarkerIndexInputChanged(e.target.value, position)}
                            />
                            <Button
                                type="primary"
                                size="small">
                                Go
                            </Button>
                        </Input.Group>
                    ) : (
                        <Tooltip title="Double click to jump to marker">
                            <p>{position + 1}</p>
                            <span>of</span>
                            <p>{markersLength}</p>
                        </Tooltip>
                    )}
                </div>
            );

            let extentLength = 0;
            let extentPosition = 0;

            if (this.state.observationExtents && this.state.observationExtents.length) {
                let indexes = _.map(this.state.observationExtents, (marker) => [keyLookup(marker.video_key, this.props.imageKeys), marker.frame, marker]);
                let sortedMarkers = _.sortBy(
                    _.filter(indexes, ([idx, _frame]) => idx > -1),
                    ([idx, _frame]) => idx,
                    ([idx, _frame]) => _frame,
                ).map((marker) => marker[2]);
                extentPosition = _.findIndex(sortedMarkers, (i) => i.id === selectedMarker.id);
                extentLength = sortedMarkers.length;
            }

            let extentIndex = (
                <div className="ContinuousObservationPosition">
                    <p>
                        <span>Section</span> {extentPosition + 1}
                    </p>
                    <span>of</span>
                    <p>{extentLength}</p>
                </div>
            );

            let filteredAmount = 0;
            let filteredExtents = 0;
            if (this.props.markers) {
                if (this.state.isContinuousObservation) {
                    let uniqueObservations = [];
                    this.props.allMatchingMarkers.forEach((item) => {
                        if (!_.find(uniqueObservations, { observation_number: item.observation_number })) {
                            uniqueObservations.push(item);
                        }
                    });
                    filteredAmount = uniqueObservations.length - this.state.uniqueContinuousObservations.length;
                    const unfilteredExtents = this.props.allMatchingMarkers.filter(
                        (item) => item.observation_number === this.props.selectedMarker.observation_number,
                    );
                    filteredExtents = unfilteredExtents.length - this.state.observationExtents.length;
                } else {
                    filteredAmount = this.props.allMatchingMarkers.length - this.props.markers.length;
                }
            }

            let conditions = [];
            if (this.props.conditionTypes) {
                conditions = _.filter(
                    this.props.conditionTypes,
                    (condition) => String(condition.marker_type).toLocaleUpperCase() === String(selectedMarker.name).toLocaleUpperCase(),
                );
            }

            let observationConditions = [];
            if (this.props.observationConditionTypes) {
                observationConditions = _.filter(
                    this.props.observationConditionTypes,
                    (condition) => String(condition.marker_type).toLocaleUpperCase() === String(selectedMarker.class).toLocaleUpperCase(),
                );
            }

            let continuousObservationSteps = this.state.observationExtents.map((item, index) => {
                let colour = "white";

                const troughingCondition = _.get(item.classifications, "troughing_condition");
                const totalPercentageInSegment = _.get(item, "total_percentage", null);

                if (troughingCondition) {
                    if (!troughingCondition.user) {
                        if (troughingCondition.auto !== "no_result") {
                            colour = "yellow";
                        }
                        if (troughingCondition.auto === "defect") {
                            colour = "red";
                        }
                        if (troughingCondition.auto === "good") {
                            colour = "green";
                        }
                        if (troughingCondition.auto === "invalid") {
                            colour = "white";
                        }
                    } else {
                        if (troughingCondition.user !== "no_result") {
                            colour = "yellow";
                        }
                        if (troughingCondition.user === "defect") {
                            colour = "red";
                        }
                        if (troughingCondition.user === "good") {
                            colour = "green";
                        }
                        if (troughingCondition.user === "invalid") {
                            colour = "white";
                        }
                    }
                } else if (totalPercentageInSegment) {
                    colour = getColorFromPercentage(totalPercentageInSegment, 80);
                }

                let step;

                if (item.id === this.props.selectedMarker.id) {
                    step = (
                        <div
                            key={item.id}
                            style={{ backgroundColor: colour, opacity: "0.8" }}
                            className="ContinuousObservationsStep StepHighlight"></div>
                    );
                } else {
                    step = (
                        <div
                            onClick={() => this.goToExtent(index + 1)}
                            key={item.id}
                            style={{ backgroundColor: colour, opacity: "0.3", cursor: "pointer" }}
                            className="ContinuousObservationsStep"></div>
                    );
                }

                return (
                    <Tooltip
                        title={
                            <div>
                                <p style={{ margin: "3px 0" }}>ID: {item.id}</p>
                                <p style={{ marginBottom: "3px" }}>Observation number: {item.observation_number}</p>
                                <p style={{ marginBottom: "3px" }}>Extent number: {item.extent_number}</p>
                            </div>
                        }>
                        {step}
                    </Tooltip>
                );
            });

            const observationClassificationOptionsMap = {
                "Scrap Rail": {
                    scrap_rail_type: [
                        { value: "scrap", tag: "Scrap Rail" },
                        { value: "strategic", tag: "Strategic Rail" },
                        { value: "future_works", tag: "Future Works" },
                    ],
                },
                Troughing: {
                    troughing_condition: [
                        { value: "defect", tag: "Defect" },
                        { value: "obscured", tag: "Obscured" },
                        { value: "cables", tag: "Cables Outside of Troughing" },
                        { value: "good", tag: "Good" },
                        { value: "uncertain", tag: "Uncertain" },
                    ],
                    troughing_type: [
                        { value: "concrete", tag: "Concrete" },
                        { value: "composite", tag: "Composite" },
                        { value: "elevated", tag: "Elevated" },
                        { value: "uncertain", tag: "Uncertain" },
                        { value: "not_troughing", tag: "Not Troughing" },
                    ],
                },
                low_ballast: {},
            };

            const observationClassificationOptions = _.get(observationClassificationOptionsMap, selectedMarker.class, {});

            const renderClassificationOptions = (setOverall) => {
                return Object.keys(observationClassificationOptions).map((item) => {
                    const renderOptions = observationClassificationOptions[item].map((option) => {
                        return (
                            <Option
                                key={option.value}
                                data_type={item}
                                value={option.value}>
                                {option.tag}
                            </Option>
                        );
                    });
                    let selectTag = "Condition";
                    if (/\b\w*type\w*\b/i.test(item)) {
                        selectTag = "Type";
                    }

                    let displayAuto = false;
                    let selectValue = "";
                    if (selectedMarker.classifications[item]) {
                        if (selectedMarker.classifications[item].user) {
                            selectValue = selectedMarker.classifications[item].user;
                        } else if (selectedMarker.classifications[item].auto) {
                            if (selectedMarker.classifications[item].auto === "no_result") {
                                selectValue = "No result";
                            } else {
                                selectValue = capitalizeFirstLetter(selectedMarker.classifications[item].auto);
                            }
                            displayAuto = true;
                        } else {
                            selectValue = "Not set";
                        }
                    } else {
                        selectValue = "Not set";
                    }

                    let overallClassificationValue = "Not set";

                    const extentClassifications = this.state.observationExtents.map((extent) => {
                        const userClassification = _.get(extent, `classifications.${item}.user`, null);
                        if (userClassification) {
                            return userClassification;
                        } else {
                            return _.get(extent, `classifications.${item}.auto`, null);
                        }
                    });
                    const uniqueClassifications = _.uniq(extentClassifications);

                    if (uniqueClassifications.length === 1 && !uniqueClassifications.includes(null)) {
                        overallClassificationValue = capitalizeFirstLetter(uniqueClassifications[0]);
                    }

                    return (
                        <div className="ContinuousObservationsSelectContainer">
                            <p className="ContinuousObservationsSelectTag">{selectTag}</p>
                            <Select
                                value={setOverall ? overallClassificationValue : selectValue}
                                className="ContinuousObservationsSelect"
                                onChange={setOverall ? this.displayModal : this.classifyObservationExtent}>
                                {renderOptions}
                            </Select>
                            {displayAuto && !setOverall && (
                                <div className="ContinuousObservationsAuto">
                                    <OBCAutoIndicator
                                        tooltip="Reviewed automatically"
                                        placement="topRight"
                                    />
                                </div>
                            )}
                        </div>
                    );
                });
            };

            markerInformationContent = (
                <div className="markerInformationContainer">
                    {!_.isNil(selectedMarker.review_status) && (
                        <div className="topRow">
                            {selectedMarker.class === "vegetation_encroachment" ? (
                                <div className={`MarkerLoadingOverlay ${this.props.loadedPercentage === 100 ? "disabled" : ""}`}>
                                    <h3>Loading Vegetation Encroachment Detections</h3>
                                    <Progress
                                        percent={this.props.loadedPercentage}
                                        status="active"
                                        showInfo={false}
                                    />
                                </div>
                            ) : null}
                            <div className="markerInformationContainer__Inner image">
                                <canvas ref={this.canvasRef}></canvas>
                            </div>

                            <div className="markerInformationContainer__Inner">
                                <div className="markerInformationContainer__Inner__Row">
                                    {(selectedMarker.name || selectedMarker.class) && (
                                        <Select
                                            className="markerInformationSelector"
                                            value={_.has(selectedMarker, "name") ? selectedMarker.name : selectedMarker.class}
                                            bordered={false}
                                            onChange={this.changeDetectionType}
                                            dropdownMatchSelectWidth={false}>
                                            {this.props.detectionTypes.map((item) => {
                                                return (
                                                    <Select.Option value={item.name || item.class}>
                                                        {item.display_name || item.name || item.class}
                                                    </Select.Option>
                                                );
                                            })}
                                        </Select>
                                    )}
                                    {this.reviewPermissions() && reviewStatus}
                                    {!_.isEmpty(this.props.markerDistance) && (
                                        <div className="markerDistance">
                                            {!this.props.markerDistance.ahead && (
                                                <FontAwesomeIcon
                                                    icon={faArrowLeft}
                                                    className="markerDistanceDirection"
                                                />
                                            )}
                                            <p className="markerDistanceText">{this.props.markerDistance.distance.toFixed(2)}m</p>
                                            {this.props.markerDistance.ahead && (
                                                <FontAwesomeIcon
                                                    icon={faArrowRight}
                                                    className="markerDistanceDirection"
                                                />
                                            )}
                                        </div>
                                    )}
                                    {!_.includes(OBSERVATION_EXPORT_BLACKLIST, selectedMarker?.class) && (
                                        <Button
                                            style={{ height: "auto", minHeight: 32 }}
                                            onClick={() => this.setState({ observationsExportOpen: true })}
                                            type="primary">
                                            Export Detections
                                        </Button>
                                    )}
                                </div>
                                <div className="markerInformationContainer__Inner__Row">
                                    <div className="markerControls">
                                        <div
                                            className="markerControls__Item"
                                            onClick={() => this.prevMarker()}>
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </div>
                                        {markerIndex}
                                        <div
                                            className="markerControls__Item"
                                            onClick={() => this.nextMarker()}>
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </div>
                                    </div>
                                    <div
                                        className="markerControls__Filter"
                                        onClick={() => this.setState({ markerThresholdFilterOpen: true })}>
                                        <FontAwesomeIcon
                                            icon={faFilter}
                                            style={{ color: "#40A9FF" }}
                                        />
                                    </div>
                                    <div className="markerControls__Filter-Count">
                                        <span>{filteredAmount} Filtered</span>
                                    </div>
                                </div>
                                <div className="markerInformationContainerGrid">
                                    {this.reviewPermissions() && (
                                        <>
                                            <span className="improveLabel">Your reviews help improve future detections</span>
                                            <span className="Label">Status: </span>
                                            <div className="Controls">
                                                {!selectedMarker.review_status ? (
                                                    <>
                                                        <button
                                                            className="reviewButton reject"
                                                            onClick={() => this.revMarker(3)}>
                                                            {shortcutLabel("Reject", "r", { disabled: !_.isEmpty(this.props.markerDistance) })}
                                                        </button>
                                                        <button
                                                            className="reviewButton verifyhide"
                                                            onClick={() => this.revMarker(2)}>
                                                            {shortcutLabel("Hide", "h", {
                                                                prefix: "Verify &",
                                                                disabled: !_.isEmpty(this.props.markerDistance),
                                                            })}
                                                        </button>
                                                        <button
                                                            className="reviewButton verify"
                                                            onClick={() => this.revMarker(1)}>
                                                            {shortcutLabel("Verify", "v", { disabled: !_.isEmpty(this.props.markerDistance) })}
                                                        </button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Select
                                                            value={selectedMarker.review_status}
                                                            onChange={this.revMarker}
                                                            dropdownMatchSelectWidth={false}
                                                            style={{ width: "50%" }}
                                                            getPopupContainer={(node) => node.parentNode}>
                                                            <Select.Option value={3}>Rejected</Select.Option>
                                                            <Select.Option value={2}>Verified & Hidden</Select.Option>
                                                            <Select.Option value={1}>Verified</Select.Option>
                                                        </Select>
                                                    </>
                                                )}
                                            </div>
                                            <div className="AutoReviewIndicator">
                                                {selectedMarker.review_auto_selected && (
                                                    <OBCAutoIndicator
                                                        className="Button"
                                                        onClick={() => {
                                                            this.revMarker(selectedMarker.review_status);
                                                        }}
                                                        tooltip="Reviewed automatically"
                                                        placement="topRight"
                                                    />
                                                )}
                                            </div>
                                        </>
                                    )}
                                    {this.reviewPermissions() && conditions.length > 0 && (
                                        <>
                                            <span className="Label">Condition: </span>
                                            <div className="Controls">
                                                <Select
                                                    ref={this.conditionSelect}
                                                    showSearch
                                                    dropdownMatchSelectWidth={false}
                                                    dropdownMenuStyle={{ maxHeight: "500px" }}
                                                    placeholder="Select condition"
                                                    optionFilterProp="children"
                                                    onChange={(e) => {
                                                        this.conditionSelect.current.blur();
                                                        this.onConditionChanged(selectedMarker.session_id, selectedMarker.id, e);
                                                    }}
                                                    value={selectedMarker.condition_id}
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                    <Option
                                                        key={0}
                                                        value={null}>
                                                        None
                                                    </Option>
                                                    {_.map(_.sortBy(conditions, "condition_name"), (type) => (
                                                        <Option
                                                            key={type.id}
                                                            value={type.id}>
                                                            {type.condition_name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            <div className="AutoReviewIndicator">
                                                {selectedMarker.condition_auto_selected && (
                                                    <OBCAutoIndicator
                                                        className="Button"
                                                        onClick={() => {
                                                            this.onConditionChanged(selectedMarker.session_id, selectedMarker.id, selectedMarker.condition_id);
                                                        }}
                                                        tooltip="Condition automatically detected"
                                                        placement="topRight"
                                                    />
                                                )}
                                            </div>
                                        </>
                                    )}

                                    {/* I realize this is super ugly, but it's keeping marker and observation logic separate until we can fully deprecate markers */}
                                    {this.reviewPermissions() && observationConditions.length > 0 && (
                                        <>
                                            <span className="Label">Condition: </span>
                                            <div className="Controls">
                                                <Select
                                                    ref={this.conditionSelect}
                                                    showSearch
                                                    dropdownMatchSelectWidth={false}
                                                    dropdownMenuStyle={{ maxHeight: "500px" }}
                                                    placeholder="Select condition"
                                                    optionFilterProp="children"
                                                    onChange={(e) => {
                                                        this.conditionSelect.current.blur();
                                                        this.onObservationConditionChanged(selectedMarker.id, e, selectedMarker.class);
                                                    }}
                                                    value={selectedMarker.condition_id}
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                    <Option
                                                        key={0}
                                                        value={null}>
                                                        None
                                                    </Option>
                                                    {_.map(_.sortBy(observationConditions, "condition_name"), (type) => (
                                                        <Option
                                                            key={type.id}
                                                            value={type.id}>
                                                            {type.condition_name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            <div className="AutoReviewIndicator">
                                                {selectedMarker.condition_auto_selected && (
                                                    <OBCAutoIndicator
                                                        className="Button"
                                                        onClick={() => {
                                                            this.onObservationConditionChanged(
                                                                selectedMarker.id,
                                                                selectedMarker.condition_id,
                                                                selectedMarker.class,
                                                            );
                                                        }}
                                                        tooltip="Condition automatically detected"
                                                        placement="topRight"
                                                    />
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            {this.renderObjectObservationClassifications(this.props.objectObservationDataTypes, selectedMarker)}
                            {selectedMarker && selectedMarker.continuous && (
                                <div className="ContinuousObservations">
                                    <Modal
                                        title={false}
                                        visible={this.state.modalVisible}
                                        footer={[
                                            <Button
                                                type="primary"
                                                onClick={() => this.setOverallClassification(true)}>
                                                Yes
                                            </Button>,
                                            <Button onClick={() => this.setOverallClassification(false)}>No</Button>,
                                            <Button onClick={() => this.setState({ modalVisible: false, overallRailClassification: "" })}>Cancel</Button>,
                                        ]}
                                        onCancel={() => this.setState({ modalVisible: false, overallRailClassification: "" })}>
                                        <p
                                            className="ContinuousObservationsModalText"
                                            style={{ margin: "5px 15px", fontWeight: 500 }}>
                                            Would you like to override the classifications of each section within this observation?
                                        </p>
                                    </Modal>

                                    <h3 className="ContinuousObservationsTitle">Observation Sections</h3>
                                    <div className="ContinuousObservationsControls">
                                        <div
                                            className="markerControls__Item"
                                            onClick={this.prevExtent}>
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </div>
                                        <div className="ContinuousObservationPosition">{extentIndex}</div>
                                        <div
                                            className="markerControls__Item"
                                            onClick={() => this.nextExtent()}>
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </div>
                                        {filteredExtents > 0 && (
                                            <p className="ContinuousObservationFiltered">
                                                {filteredExtents === 1 ? `${filteredExtents} Section` : `${filteredExtents} Sections`} Filtered
                                            </p>
                                        )}
                                    </div>
                                    <div className="ContinuousObservationsSteps">{continuousObservationSteps}</div>

                                    {!_.isEmpty(observationClassificationOptions) && (
                                        <div className="ContinuousObservationsReviewContainer">
                                            <div className="ContinuousObservationsContainer">
                                                <span className="ContinuousObservationsTag">Section Classification:</span>
                                                <div className="ContinuousObservationsSelects">{renderClassificationOptions(false)}</div>
                                            </div>

                                            <div className="ContinuousObservationsContainer">
                                                <span className="ContinuousObservationsTag">Overall Classification:</span>
                                                <div className="ContinuousObservationsSelects">{renderClassificationOptions(true)}</div>
                                            </div>

                                            {selectedMarker.class === "Scrap Rail" && (
                                                <div className="ContinuousObservationsContainer">
                                                    <span className="ContinuousObservationsTag">Length:</span>
                                                    <div className="ContinuousObservationsSelects">
                                                        <Select
                                                            className="ScrapRailLength"
                                                            placeholder="Select length"
                                                            onChange={(e) => this.props.dispatch(classifyScrapRailLength(selectedMarker.id, e))}
                                                            value={_.get(selectedMarker, ["classifications", "scrap_rail_length", "user"])}>
                                                            <Option value="under_10ft">Under 10ft</Option>
                                                            <Option value="over_10ft">Over 10ft</Option>
                                                        </Select>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {selectedMarker.class === "Structure ID Plate" && (
                        <div className="StructureIDPlateSelects">
                            <div className="StructureIDPlateSelect">
                                <p className="label">
                                    OCR Result:{" "}
                                    <span className="label-bold">
                                        {AssetIDHelper.from_class_specific_data(_.get(selectedMarker, "class_specific_data")).csv_to_slashes()}
                                    </span>
                                </p>
                                <div className="container">
                                    <Input
                                        placeholder="Override OCR result"
                                        value={this.state.ocrResult}
                                        className="input"
                                        onChange={this.setOCRResult}
                                    />
                                    <Button
                                        type="primary"
                                        className="submit"
                                        onClick={this.handleOCRChange}
                                        disabled={this.state.ocrResult === "" || this.state.ocrVerificationMessage}>
                                        Save
                                    </Button>
                                </div>
                            </div>

                            {this.state.ocrVerificationMessage && <p className="ocrWarning">{this.state.ocrVerificationMessage}</p>}
                        </div>
                    )}
                    {this.renderThermalHotspotDetails()}
                    {this.props.selectedMarker && this.props.selectedMarker.name === "Thermal Hotspot" && (
                        <MarkerHistoryComponent openPreviwWithImage={this.openPreviewWithImage} />
                    )}
                    {this.props.selectedMarker && this.props.selectedMarker.class === "Thermal Hotspot" && (
                        <ObservationHistoryComponent
                            key={this.props.selectedMarker.id}
                            observation={this.props.selectedMarker}
                            openPreviewWithImage={this.openPreviewWithImage}
                        />
                    )}
                </div>
            );
        }

        return (
            <>
                <Modal
                    className="DetectionPreviewImageModal"
                    title={false}
                    visible={this.state.previewOpen}
                    onCancel={() => this.closePreviewModal()}
                    footer={false}>
                    <img
                        src={this.state.preveiwImgSrc}
                        className="TippyHistoryImage"
                        alt="Thermal Hotspot"
                        crossOrigin={"anonymous"}
                    />
                    <div className="PreviewImageFooter">
                        {this.state.observation ? (
                            <>
                                <span>Observed on {new Date(this.state.observation.first_seen_ts).toLocaleDateString()}</span>
                                <a
                                    href={`https://view.aivr.video/view/${this.state.observation.session_id}/${this.state.observation.first_seen_ts}`}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <Button>View in session</Button>
                                </a>
                            </>
                        ) : null}
                    </div>
                </Modal>
                <MarkerThresholdFiltersModal
                    markerThresholdFilterOpen={this.state.markerThresholdFilterOpen}
                    setMarkerThresholdFilterOpen={() => this.setState({ markerThresholdFilterOpen: false })}
                />

                {this.state.observationsExportOpen && (
                    <MarkerExportModal
                        markerType={
                            this.props.selectedMarker.class
                                ? `${this.props.selectedMarker.class}_observations${this.props.selectedMarker.continuous ? "_continuous" : ""}`
                                : this.props.selectedMarker.name
                        }
                        closeModal={() => this.setState({ observationsExportOpen: false })}
                    />
                )}

                <div
                    className="markerButtons"
                    style={{ marginTop: "15px" }}>
                    <MarkerPanel displayDownload={false} />
                </div>

                {markersLength > 0 ? (
                    markerInformationContent
                ) : (
                    <div className="markerInformationContainer__Empty">
                        <div
                            className="markerControls__Filter-Button"
                            onClick={() => this.setState({ markerThresholdFilterOpen: true })}>
                            <span>Edit Filters</span>
                            <FontAwesomeIcon icon={faFilter} />
                        </div>
                        <p>
                            All{" "}
                            <span>
                                {this.props.allMatchingMarkers &&
                                this.props.allMatchingMarkers.length &&
                                _.has(this.props.allMatchingMarkers[0], "observation_number")
                                    ? _.uniqBy(this.props.allMatchingMarkers, "observation_number").length
                                    : this.props.allMatchingMarkers.length}
                            </span>{" "}
                            markers filtered
                        </p>
                    </div>
                )}
            </>
        );
    }
}

const filteredMarkers = memoizeOne(
    (
        markers,
        observations,
        routeID,
        selectedMarker,
        markerReviewFilters,
        detectionTypes,
        thresholdFilters,
        defaultScores,
        markerConditionFilter,
        observationFilters,
    ) => {
        const mks = _.get(markers.perSession, [routeID], []);
        let filtered;
        if (selectedMarker && selectedMarker.hasOwnProperty("observation_number")) {
            filtered = filterSessionObservations(
                observations.filter((marker) => {
                    return marker.class === selectedMarker.class && markerReviewFilters.includes(marker.review_status);
                }),
                observationFilters,
            );
        } else {
            filtered = filterMarkers(mks, selectedMarker.name, markerReviewFilters, detectionTypes, thresholdFilters, defaultScores, markerConditionFilter);
        }
        return filtered.filter((marker) => marker.source !== "ANNOTATION");
    },
);

const currentMarker = memoizeOne((filteredMarkers, currentVideoKey, imageKeys, currentIndex, timeOffset, previousMarker) => {
    return findClosestMarker(filteredMarkers, currentVideoKey, imageKeys, currentIndex, timeOffset, previousMarker);
});

const calculateMarkerDistance = memoizeOne((mapPosition, markerCoords, currentVideoKey, closestMarker, video, currentIndex, offset) => {
    const currentFrame = calculateFrame(video, currentIndex, offset);
    const markerFrame = _.get(closestMarker, "frame");
    const markerVideoKey = _.get(closestMarker, "video_key");
    let _markerCoords = markerCoords;

    if (
        (currentVideoKey === markerVideoKey && currentFrame === markerFrame) ||
        !mapPosition ||
        !markerCoords ||
        !closestMarker ||
        (markerCoords[0] === 0 && markerCoords[1] === 0)
    ) {
        return {};
    }

    if (_.has(closestMarker, "observation_number")) {
        _markerCoords = [markerCoords[1], markerCoords[0]];
    }

    return {
        distance: calculatePointDistance([mapPosition[1], mapPosition[0]], _markerCoords),
        ahead: markerVideoKey === currentVideoKey ? markerFrame > currentFrame : videoKeyToTimestamp(markerVideoKey) > videoKeyToTimestamp(currentVideoKey),
    };
});

const getDetectionTypes = memoizeOne((markers, observations, filters) => {
    const uniqueDetectionTypes = [];
    const uniqueDetectionNames = [];
    markers.forEach((item) => {
        if (!uniqueDetectionNames.includes(item.name) && filters.includes(item.review_status)) {
            uniqueDetectionNames.push(item.name);
            uniqueDetectionTypes.push(item);
        }
    });
    observations.forEach((item) => {
        if (!uniqueDetectionNames.includes(item.class) && filters.includes(item.review_status)) {
            uniqueDetectionNames.push(item.class);
            uniqueDetectionTypes.push(item);
        }
    });
    return uniqueDetectionTypes;
});

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];
const mapStateToProps = ({
    userDetails,
    dashboards,
    playlist,
    markers,
    sessions,
    markerReviewFilters,
    detectionTypes,
    markerThresholdFilters,
    defaultMarkersThresholds,
    markerConditionFilter,
    sessionObservations,
    observationFilters,
    csrfToken,
    objectObservationDataTypes,
    observationDetections,
    totalDetections,
}) => {
    const sessionID = _.get(playlist, ["data", "routeID"], 0);
    const markersPerSession = _.get(markers, ["perSession", sessionID], []);
    const allMatchingMarkers = _.filter(markersPerSession, (item) => item.name === markers.selectedMarker.name);
    const allMatchingObservations = _.filter(sessionObservations, (item) => item.class === markers.selectedMarker.class);
    const dashboardID = userDetails.dashboardAccessID;
    const currentDashboard = _.find(dashboards, (dash) => dash.access_id === dashboardID);

    const defThresholds = defaultMarkersThresholds[sessionID];

    const isVideo = playlist.position.isVideo;
    const sourceIndex = playlist.position.sourceIndex;
    const _playlist = isVideo ? _.get(playlist.data, ["video", sourceIndex], []) : playlist.data.image;
    const index = playlist.position.currentIndex;
    const timeOffset = playlist.position.currentTimeOffset;

    const currentVideoKey = _.get(_playlist, [index, 0]);
    const _markers = filteredMarkers(
        markers,
        sessionObservations,
        playlist.data.routeID,
        markers.selectedMarker,
        markerReviewFilters,
        detectionTypes,
        markerThresholdFilters,
        defThresholds,
        markerConditionFilter,
        observationFilters,
    );
    const closestMarker = currentMarker(_markers, currentVideoKey, _playlist, index, timeOffset, _.get(markers, "selectedMarker", {}));
    const mapPosition = _.get(playlist.position, "coords", null);
    const markerPosition = _.get(closestMarker, "coords", null);

    const sessionMarkersArray = _.get(markers, ["perSession", playlist.data.routeID], []);
    const sessionObservationsArray = Array.isArray(sessionObservations) ? sessionObservations : [];
    const combinedMarkers = [...sessionMarkersArray, ...sessionObservationsArray].filter((item) => markerReviewFilters.includes(item.review_status));

    const currentSession = sessions[playlist.data.routeID];
    const loadedPercentage = totalDetections ? (observationDetections.length / totalDetections) * 100 : 0;

    return {
        currentDashboard,
        selectedMarker: closestMarker ? closestMarker : {},
        sessions,
        sessionID: sessionID,
        session: sessions[sessionID],
        allMatchingMarkers: allMatchingMarkers.length ? allMatchingMarkers : allMatchingObservations,
        markers: _markers,
        imageKeys: _playlist,
        currentIndex: playlist.position.currentIndex,
        currentTimeOffset: timeOffset,
        data_pool_permissions: _.get(currentDashboard, ["data_pool_permissions"], EMPTY_OBJECT),
        userDetails,
        conditionTypes: _.get(markers.conditionTypes, [currentSession?.map_system], EMPTY_ARRAY),
        observationConditionTypes: _.get(markers.observationConditionTypes, [currentSession?.map_system], EMPTY_ARRAY),
        sessionObservations,
        markerReviewFilters,
        markerDistance: calculateMarkerDistance(mapPosition, markerPosition, currentVideoKey, closestMarker, _playlist, index, timeOffset),
        detectionTypes: getDetectionTypes(markersPerSession, sessionObservations, markerReviewFilters),
        combinedMarkers,
        currentVideoKey,
        playlist: _playlist,
        csrfToken,
        objectObservationDataTypes,
        observationDetections,
        loadedPercentage,
    };
};

export default connect(mapStateToProps)(MarkerInformation);
